<template lang="pug">
	.jnx-footer
		.footer-container
			.footer-container-top
				.top
					.element.with-border
						h1 Services

						ul
							li
								app-link(:to="navLinks.doItYourself" id="footer_doityourself_btn")
									span(:class="{ 'footer-active': currentPath === '/do-it-yourself' }") Do It Yourself / Residential
							li
								app-link(:to="navLinks.fullService" id="footer_fullservice_btn")
									span(:class="{ 'footer-active': currentPath === '/full-service' }") Full Service Consulting
							li
								app-link(:to="navLinks.prices" id="footer_price_shedule_btn")
									span(:class="{ 'footer-active': currentPath === '/prices' }") Service and Price Schedule
							li
								app-link(:to="navLinks.termsAndConditions" id="footer_termsandconditions_btn")
									span(:class="{ 'footer-active': currentPath === '/terms-and-conditions' }") Terms and Conditions

					.element.with-border
						h1 Quick Links
						ul
							li
								a(:href="navLinks.myProjects" id="footer_myproyects_btn")
									span(:class="{ 'footer-active': currentPath === '/project/list' }") My Projects
							li
								a(:href="navLinks.activeProject" id="footer_editactiveproject_btn")
									span Edit Active Project
							li
								a(:href="navLinks.myAccount" id="footer_myaccount_btn")
									span(:class="{ 'footer-active': currentPath === '/my-account' }") My Account
							li.ghost-space &nbsp;

					.element.with-border
						h1 Resources
						ul
							li
								app-link(:to="navLinks.faq")
									span FAQ
							li
								app-link(:to="navLinks.complianceWizard" id="footer_fullservice_btn")
									span(:class="{ 'footer-active': currentPath === '/complianceWizard' }") Full Service Quote
							li
								app-link(:to="navLinks.contactUs" id="footer_customerserice_btn")
									span(:class="{ 'footer-active': currentPath === '/contact-us' }") Customer Service
							li
								app-link(:to="navLinks.resourceLinks" id="footer_resourcelinks_btn")
									span(:class="{ 'footer-active': currentPath === '/resource-links' }") Resource Links

					.element
						h1 Contact Us
						ul.without-border
							li {{ phone }}
							li <a :href="`mailto:${email}`"><span class="mail-footer">{{ email }}</span></a>
							li {{ address }}

		.element-down
			.down
				p
					<span>Copyright © {{getYear}} EasyTitle24.com <br/><small>{{build}}</small></span>
</template>

<script>
import {Organization} from 'janux-people'

export default {
	name: 'jnx-footer',
	props: ['build'],
	data () {
		return {
			navLinks: {},
			currentPath: '',
			getYear: '',
			config: null,
			mountedWorks: false,
			email: 'customer.service@easytitle24.com',
			phone: '(415) 259-4068',
			address: '654 Oakland Ave. Oakland 94611 California, USA'
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		this.isStagingEnv = this.$e24Common.storageService.findItem('isStagingEnv', true)
	},
	created () {
		this._getYear()
		this.config = this.$e24Common.storageService.findItem('config', true)
		if (this.config) {
			try {
				this.config.company = Organization.fromJSON(this.config.company)
				this.phone = `(${this.config.company.phoneNumber().areaCode}) ${this.config.company.phoneNumber().number}`
				this.email = this.config.company.emailAddress().address
				this.address = `${this.config.company.postalAddress().line1} ${this.config.company.postalAddress().cityText} ${this.config.company.postalAddress().postalCode} ${this.config.company.postalAddress().stateText}, ${this.config.company.postalAddress().country}`
			} catch (error) {
				console.log(error)
			}
		}
	},
	methods: {
		readPath: function () {
			let route = this.$route.path
			console.debug('the route is in footer is ' + route)
			this.currentPath = route
		},
		_getYear: function () {
			let d = new Date()
			let n = d.getFullYear()
			this.getYear = n
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/components/footer.vue